// extracted by mini-css-extract-plugin
module.exports = {"input":"MailingList_input__3_hHl","content":"MailingList_content__CYE15"};